var _path, _g, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3703_23465",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 22,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.13745H27V29.0001H5V2.13745Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3703_23465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.5002C26.1039 19.8578 19.8211 25.1002 17.2281 27.09C16.5682 27.5963 15.6727 27.6017 15.0068 27.1034C12.3613 25.1238 5.89704 19.8676 5.5 15.5002C5.5 9.82717 9.83422 2.00024 16.1223 2.00024C22.4103 2.00024 26.5 9.82717 26.5 15.5002Z",
    fill: "#E55107"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11,
    fill: "#E55107"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 9,
    fill: "#E55107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 19V15.6512L15.4438 14.5349L14.8813 16.9907L11 16.2093L11.225 15.093L13.925 15.6512L14.825 11.1302L13.8125 11.5209V13.4186H12.6875V10.7953L14.9094 9.84651C15.2375 9.70698 15.4789 9.61628 15.6336 9.57442C15.7883 9.53256 15.9312 9.51163 16.0625 9.51163C16.2594 9.51163 16.4422 9.56279 16.6109 9.66512C16.7797 9.76744 16.9156 9.90233 17.0187 10.0698L17.5812 10.9628C17.825 11.3535 18.1555 11.6744 18.5727 11.9256C18.9898 12.1767 19.4656 12.3023 20 12.3023V13.4186C19.3812 13.4186 18.8023 13.2907 18.2633 13.0349C17.7242 12.7791 17.2719 12.4419 16.9062 12.0233L16.5688 13.6977L17.75 14.814V19H16.625ZM16.9062 9.23256C16.5969 9.23256 16.332 9.12326 16.1117 8.90465C15.8914 8.68605 15.7812 8.42326 15.7812 8.11628C15.7812 7.8093 15.8914 7.54651 16.1117 7.32791C16.332 7.1093 16.5969 7 16.9062 7C17.2156 7 17.4805 7.1093 17.7008 7.32791C17.9211 7.54651 18.0312 7.8093 18.0312 8.11628C18.0312 8.42326 17.9211 8.68605 17.7008 8.90465C17.4805 9.12326 17.2156 9.23256 16.9062 9.23256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalk);
export default __webpack_public_path__ + "static/media/walk.7d4418108aeb7c2eefb6e171a599caf3.svg";
export { ForwardRef as ReactComponent };